import React from 'react';
import { Routes } from 'react-router-dom';

import { sellerAreaRoutes } from '@seller-area/routers/seller-area-router';
import { legacyRedirectRoutes } from '@seller-area/routers/routes/legacy-redirect-routes';

import { getProposalRoutes, getPublicRoutes, getGdPublicRoutes } from './routes';

const MainRouter: React.FC = () => {
  return (
    <Routes>
      {/* Redirects from the old sales web paths */}
      {legacyRedirectRoutes()}

      {/* Seller area */}
      {sellerAreaRoutes()}

      {/* Public proposal routes */}
      {getProposalRoutes()}
      {getGdPublicRoutes()}

      {/* Public routes */}
      {getPublicRoutes()}
    </Routes>
  );
};

export default MainRouter;
